
    <div
      *ngIf="deletable || editable"
      class="d-flex d-flex-gap align-items-center"
    >
      <fieldmagic-primary-button
        *ngIf="editable"
        purpose="icon"
        icon="pencil"
        (click)="onEdit()"
      >
      </fieldmagic-primary-button>

      <fieldmagic-primary-button
        *ngIf="deletable"
        purpose="delete-icon"
        (click)="onDelete()"
      >
      </fieldmagic-primary-button>
    </div>
  